<!--
 * @Author: luyaj 1579618152@qq.com
 * @Date: 2025-03-13 19:52:31
 * @LastEditors: luyaj 1579618152@qq.com
 * @LastEditTime: 2025-04-19 21:48:00
 * @FilePath: \my-vue-project\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <AppHeader></AppHeader>
  <router-view />
</template>

<script>
import { onMounted } from "vue";
import AppHeader from "./components/AppHeader.vue";
import { applyGlobalSeo } from "./seo";
import { buildOrganization, buildWebSite } from "./seo/jsonld";

export default {
  components: {
    AppHeader,
  },
  setup() {
    onMounted(() => {
      applyGlobalSeo([buildOrganization(), buildWebSite()]);
    });
  },
};
</script>
 
<style>
body,
html {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100%;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
body::-webkit-scrollbar,
html::-webkit-scrollbar {
  display: none;
}
#app {
  width: 100%;
  min-height: 100vh;
  min-width: 0;
  overflow-x: hidden;
  position: relative;
}
</style>
